import setExternalBillingInCart from './setExternalBillingInCart';

const resetExternalBillingInCart = () => setExternalBillingInCart({ code: undefined });

export default resetExternalBillingInCart;
